import { ShieldAlert } from "lucide-react";

/**
 * PkiModulTrennungBanner · Anzeige der Modul-2/5-Trennung-Findings (Regel 10).
 *
 * Therapie-Inhalte (Insulingabe, BZ-Messung, Medikamentenmanagement,
 * Wundversorgung) gehören NICHT in Modul 2 (Kognition), sondern in Modul 5.
 * Diese Trennung wird bei MD-Begutachtungen regelmäßig geprüft.
 *
 * Props:
 *   data · {
 *     regel, count, severity, label,
 *     findings: [{regel_id, regel_name, severity, score_impact, problem, hinweis, empfehlung}]
 *   }
 */
export default function PkiModulTrennungBanner({ data }) {
  if (!data || !Array.isArray(data.findings) || data.findings.length === 0) return null;
  const rot = (data.severity || "rot") === "rot";
  const cls = rot
    ? "border-brand-darkred/45 bg-brand-darkred/8 text-brand-darkred"
    : "border-saffron/55 bg-saffron/15 text-clay-dark";

  return (
    <section
      data-testid="pki-modul-trennung-banner"
      className={`rounded-2xl border ${cls} p-5 md:p-6 space-y-4`}
    >
      <header className="flex items-start gap-3">
        <ShieldAlert className="h-5 w-5 mt-0.5 flex-shrink-0" strokeWidth={2.2} />
        <div className="space-y-1">
          <h3 className="text-[14px] font-bold tracking-[0.04em] uppercase">
            NBA-Modul-Trennung · Kognition vs. Therapie
          </h3>
          <p className="text-[13px] leading-relaxed">
            {data.label}{" · "}<strong>{data.count}</strong>{" Treffer"}
          </p>
        </div>
      </header>

      <ul className="space-y-3" data-testid="pki-modul-trennung-list">
        {data.findings.map((f, idx) => (
          <li
            key={idx}
            data-testid={`pki-modul-trennung-item-${idx}`}
            className="rounded-xl border border-cream-200 bg-white/70 p-4 space-y-2"
          >
            <div className="text-[12px] font-bold uppercase tracking-[0.08em] text-sand-700">
              {f.regel_name}
            </div>
            <p className="text-[13px] text-sand-800 leading-snug">
              <span className="font-semibold">Problem:</span> {f.problem}
            </p>
            {f.hinweis && (
              <p className="text-[13px] text-sand-700 leading-snug">
                <span className="font-semibold">Warum relevant:</span> {f.hinweis}
              </p>
            )}
            {f.empfehlung && (
              <p className="text-[13px] text-sage-dark leading-snug">
                <span className="font-semibold">Empfehlung:</span> {f.empfehlung}
              </p>
            )}
          </li>
        ))}
      </ul>
    </section>
  );
}
